<template>
  <div class="container">
    <router-view :key="key" />
  </div>
</template>

<script>
  export default {
    name: "appMian",
    computed: {
      key() {
        return this.$route.path
      }
    },
    mounted() {
      // console.log('this.$route.path',this.$route)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/components/main.vue